import { useContext } from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { CartContext } from "../../Context/CartContext";
import { AddToCartPopUp } from "../../components/AddToCartPopUp";
import { EventCalculatorWizard } from "../../components/EventCalculator";

export function EventCalculatorPage() {
  const { showCartPopUp } = useContext(CartContext);

  return (
    <Box bg="#f8f8f8" minH="100vh">
      <Navbar />
      <Box pt={{ base: "120px", md: "160px" }} pb={{ base: "24px", md: "32px" }}>
        <EventCalculatorWizard variant="page" />
      </Box>
      <Footer />
      {showCartPopUp && <AddToCartPopUp />}
    </Box>
  );
}
